import {
  RadixHoverDropdown,
  DocumentNumberRangeFieldV2 as DocumentNumberRangeField,
  FormFieldV2 as FormField,
  SearchFieldV2 as SearchField
} from '@/components/custom/erp';
import {
  accountSearchColumns,
  giaoDichSearchColumns,
  locationSearchColumns,
  loSearchColumns
} from '@/constants/search-columns';

import { QUERY_KEYS } from '@/constants/query-keys';
import { Label } from '@/components/ui/label';
import { TaiKhoan } from '@/types/schemas';

interface OtherTabProps {
  searchFieldStates: {
    transaction: BanHangRecord | null;
    setTransaction: (transaction: BanHangRecord | null) => void;
    accountVatTu: TaiKhoan | null;
    setAccountVatTu: (account: TaiKhoan | null) => void;
    accountDoanhThu: TaiKhoan | null;
    setAccountDoanhThu: (account: TaiKhoan | null) => void;
    accountGiaVon: TaiKhoan | null;
    setAccountGiaVon: (account: TaiKhoan | null) => void;
    lot: BanHangRecord | null;
    setLot: (lot: BanHangRecord | null) => void;
    location: BanHangRecord | null;
    setLocation: (location: BanHangRecord | null) => void;
  };
}

const OtherTab: React.FC<OtherTabProps> = ({ searchFieldStates }) => {
  return (
    <div className='h-[360px] space-y-2 p-4' style={{ width: '800px', minWidth: '800px' }}>
      <div className='flex flex-col space-y-1'>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Mã giao dịch:</Label>
          <div className='w-96'>
            <SearchField
              type='text'
              displayRelatedField='ten_gd'
              columnDisplay='ma_gd'
              searchEndpoint='/api/transactions'
              searchColumns={giaoDichSearchColumns}
              dialogTitle='Danh mục giao dịch'
              value={searchFieldStates.transaction?.ma_gd || ''}
              onRowSelection={searchFieldStates.setTransaction}
            />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Tài khoản vật tư:</Label>
          <div className='flex-1'>
            <SearchField<TaiKhoan>
              type='text'
              displayRelatedField='name'
              columnDisplay='code'
              searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
              searchColumns={accountSearchColumns}
              dialogTitle='Danh mục tài khoản'
              value={searchFieldStates.accountVatTu?.code || ''}
              onRowSelection={searchFieldStates.setAccountVatTu}
            />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Tài khoản doanh thu:</Label>
          <div className='flex-1'>
            <SearchField<TaiKhoan>
              type='text'
              displayRelatedField='name'
              columnDisplay='code'
              searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
              searchColumns={accountSearchColumns}
              dialogTitle='Danh mục tài khoản'
              value={searchFieldStates.accountDoanhThu?.code || ''}
              onRowSelection={searchFieldStates.setAccountDoanhThu}
            />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Tài khoản giá vốn:</Label>
          <div className='flex-1'>
            <SearchField<TaiKhoan>
              type='text'
              displayRelatedField='name'
              columnDisplay='code'
              searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
              searchColumns={accountSearchColumns}
              dialogTitle='Danh mục tài khoản'
              value={searchFieldStates.accountGiaVon?.code || ''}
              onRowSelection={searchFieldStates.setAccountGiaVon}
            />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Mã lô:</Label>
          <div className='flex-1'>
            <SearchField
              type='text'
              displayRelatedField='ten_lo'
              columnDisplay='ma_lo'
              searchEndpoint={`/${QUERY_KEYS.LO}/`}
              searchColumns={loSearchColumns}
              dialogTitle='Danh mục lô'
              value={searchFieldStates.lot?.ma_lo || ''}
              onRowSelection={searchFieldStates.setLot}
            />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Mã vị trí:</Label>
          <div className='flex-1'>
            <SearchField
              type='text'
              displayRelatedField='location_name'
              columnDisplay='location_code'
              searchEndpoint={`/${QUERY_KEYS.VI_TRI}/`}
              searchColumns={locationSearchColumns}
              dialogTitle='Danh mục vị trí'
              value={searchFieldStates.location?.location_code || ''}
              onRowSelection={searchFieldStates.setLocation}
            />
          </div>
        </div>
        <DocumentNumberRangeField formMode={'view'} label='Số c/từ (từ/đến)' />
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Diễn giải:</Label>
          <div className='flex-1'>
            <FormField name='description' type='text' className='w-96' />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Mẫu lọc báo cáo:</Label>
          <div className='flex items-center gap-1'>
            <FormField
              name='reportFilterTemplate'
              type='select'
              options={[{ value: 'user_filter', label: 'Người dùng tự lọc' }]}
              className='w-96'
            />

            <div className='h-9 w-9 flex-shrink-0'>
              {/* Fixed size container */}
              <RadixHoverDropdown
                iconNumber={624}
                items={[
                  {
                    value: 'save_new',
                    label: 'Lưu mẫu mới',
                    icon: 7,
                    onClick: () => undefined
                  },
                  {
                    value: 'save_overwrite',
                    label: 'Lưu đè vào mẫu đang chọn',
                    icon: 75,
                    onClick: () => console.log('Overwrite current filter template')
                  },
                  {
                    value: 'delete',
                    label: 'Xóa mẫu đang chọn',
                    icon: 8,
                    onClick: () => console.log('Delete current filter template')
                  }
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherTab;
